import { TableCellHandleMenu } from './table-cell-handle-menu/table-cell-handle-menu.tsx';
import { TableExtendRowColumnButtons } from './table-extend-row-column-button/table-extend-row-column-button.tsx';
import { TableHandle } from './table-handle/table-handle.tsx';
import { TableSelectionOverlay } from './table-selection-overlay/table-selection-overlay.tsx';

export function TableNodeUiPlugins() {
    return (
        <>
            <TableHandle />
            <TableSelectionOverlay
                showResizeHandles={true}
                cellMenu={props => (
                    <TableCellHandleMenu
                        editor={props.editor}
                        onMouseDown={e => props.onResizeStart?.('br')(e)}
                    />
                )}
            />
            <TableExtendRowColumnButtons />
        </>
    );
}
